import styled from "@emotion/styled";
import { StyledSettingTitle } from "../SettingCommon.styles";

export const SurveySubtitle = styled(StyledSettingTitle)(({ theme }) => ({
  fontWeight: theme.fontWeight.BOLD,
  marginBottom: 16,
}));
